export default __webpack_public_path__ + "static/media/frugt.01e24bcd.jpg";